import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { GuestGuard } from './shared/guards/guest.guard';
import { AuthGuard } from './shared/guards/auth.guard';
import { AutologinComponent } from './auth/autologin/autologin.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home-lold/home.module').then((m) => m.HomeModule),
  },
  { path: 'auth', component: AutologinComponent },
  {
    path: 'login',
    loadChildren: () =>
      import('./auth/login/login.module').then((m) => m.LoginModule),
    canActivate: [GuestGuard],
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./auth/register/register.module').then((m) => m.RegisterModule),
    canActivate: [GuestGuard],
  },
  {
    path: 'verify-email',
    loadChildren: () =>
      import('./auth/verify-email/verify-email.module').then(
        (m) => m.VerifyEmailModule
      ),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./auth/forgot-password/forgot-password.module').then(
        (m) => m.ForgotPasswordModule
      ),
    canActivate: [GuestGuard],
  },
  
  {
    path: 'reset-password/:email/:token',
    loadChildren: () =>
      import('./auth/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordModule
      ),
  },
  
 
  
 
  
 {
    path: 'account/profile',
    loadChildren: () =>
      import('./account/profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [AuthGuard],
  },
 
 
  

 
 
  {
    path: 'blog',
    loadChildren: () => import('./blog/blog.module').then((m) => m.BlogModule),
  },
 
 
  
  // Hand-written content pages linked from the footer. These paths are the
  // ones published inside the legal documents themselves
  // (https://wavezio.com/terms-of-use, /privacy-policy, /cookie-policy,
  // /founding-terms), so do not rename them without updating those documents.
  {
    path: 'about-us',
    title: 'About Wavezio',
    loadComponent: () =>
      import('./pages/about-us/about-us.component').then(
        (m) => m.AboutUsComponent
      ),
  },
  {
    path: 'how-it-works',
    title: 'How Wavezio works',
    loadComponent: () =>
      import('./pages/how-it-works/how-it-works.component').then(
        (m) => m.HowItWorksComponent
      ),
  },
  {
    path: 'faqs',
    title: 'FAQ | Wavezio',
    loadComponent: () =>
      import('./pages/faqs/faqs.component').then((m) => m.FaqsComponent),
  },
  {
    path: 'contact-us',
    title: 'Contact Wavezio',
    loadComponent: () =>
      import('./pages/contact-us/contact-us.component').then(
        (m) => m.ContactUsComponent
      ),
  },
  {
    path: 'privacy-policy',
    title: 'Privacy Policy | Wavezio',
    loadComponent: () =>
      import('./pages/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
  },
  {
    path: 'terms-of-use',
    title: 'Terms & Conditions | Wavezio',
    loadComponent: () =>
      import('./pages/terms-of-use/terms-of-use.component').then(
        (m) => m.TermsOfUseComponent
      ),
  },
  {
    path: 'cookie-policy',
    title: 'Cookie Policy | Wavezio',
    loadComponent: () =>
      import('./pages/cookie-policy/cookie-policy.component').then(
        (m) => m.CookiePolicyComponent
      ),
  },
  {
    path: 'founding-terms',
    title: 'Founding Fix & Fetch Membership Terms | Wavezio',
    loadComponent: () =>
      import('./pages/founding-terms/founding-terms.component').then(
        (m) => m.FoundingTermsComponent
      ),
  },
  {
    path: 'prohibited-listings-policy',
    title: 'Prohibited Listings, Content & Services Policy | Wavezio',
    loadComponent: () =>
      import(
        './pages/prohibited-listings-policy/prohibited-listings-policy.component'
      ).then((m) => m.ProhibitedListingsPolicyComponent),
  },

  // Old CMS-backed URLs for the same pages, kept alive for anything already
  // linking to them.
  { path: 'p/about-us', pathMatch: 'full', redirectTo: 'about-us' },
  { path: 'p/how-it-works', pathMatch: 'full', redirectTo: 'how-it-works' },
  { path: 'p/faqs', pathMatch: 'full', redirectTo: 'faqs' },
  { path: 'p/faq', pathMatch: 'full', redirectTo: 'faqs' },
  { path: 'p/contact-us', pathMatch: 'full', redirectTo: 'contact-us' },
  { path: 'p/privacy-policy', pathMatch: 'full', redirectTo: 'privacy-policy' },
  { path: 'p/terms-of-use', pathMatch: 'full', redirectTo: 'terms-of-use' },
  { path: 'p/cookie-policy', pathMatch: 'full', redirectTo: 'cookie-policy' },

 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
